import { CategoryItem } from 'components/main-page/home-page/product-by-category/category-item/CategoryItem'
import { useState } from 'react'
import { constructOptionMultipleSelect } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API_PRODUCT_BY_CATEGORY } from 'services/api-home-page/apiProductByCategory'

export const CategoryItemContainer = ({ productByCategoryDetail, onChangeForm, errorForm }) => {
    const copyItems = [...(productByCategoryDetail?.categories || [])]
    const [optionsProduct, setOptionsProduct] = useState([])
    const { fetching: getProductList } = useFetch(API_PRODUCT_BY_CATEGORY.PRODUCT_LIST)

    const onSearchProduct = (keyword) => {
        getProductList({ search: keyword }).then((response) => {
            const newOption = constructOptionMultipleSelect(response?.data, 'name', 'id')
            setOptionsProduct(newOption)
        })
    }

    const setItems = (items) => {
        onChangeForm({ categories: items })
    }

    const onChangeItem = (e) => {
        const { name, value, index } = e
        copyItems[index][name] = value
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                category_name: null,
                product_ids: [],
            },
        ])
    }

    const props = {
        items: copyItems,
        setItems,
        onChangeItem,
        optionsProduct,
        onSearchProduct,
        onAddNewItem,
        errorForm,
    }

    return <CategoryItem {...props} />
}
